const PAYMENT_ERROR_COMPONENT_PROPS = {
  image: 'illustration_confirmation_error',
  dataTestId: 'payment-error-component',
  variant: 'DEFAULT',
};

export { PAYMENT_ERROR_COMPONENT_PROPS };
